import React, { Component } from 'react';
import ReactTable from "react-table-6";
import "react-table-6/react-table.css";
import $ from "jquery";
import { ToastContainer, toast } from "react-toastify";
import Loader from 'react-loader-spinner';
import { DialogComponent } from '@syncfusion/ej2-react-popups';

class OutputSpreadsheet extends Component {
    constructor() {
        super();
        this.state = {
            data: [],
            pageNum: null,
            editedId: "-1",
            showLoader: true,
            hideDeletePopup: false
        };
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };

        this.settings = { effect: 'Zoom', duration: 600, delay: 0 };

        //for delete dialog component ok click
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteOutputSpreadSheetApi(this.state.propsId)
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
    }

    componentDidMount() {
        var outputSpreadsheetController = this;
        setTimeout(() => {
            outputSpreadsheetController.fetchOutputSpreadSheetDataApi();
        }, 300);
        document.addEventListener("projectChanged", function (event) {
            outputSpreadsheetController.projectId = event.projectId;
            outputSpreadsheetController.fetchOutputSpreadSheetDataApi(event.projectId);
        });
    }

    fetchOutputSpreadSheetDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        let data = { projectId: projectId }
        let outputSpreadsheetController = this;
        $.ajax({
            url: "/api/spreadsheet-intent",
            type: 'GET',
            async: false,
            headers: {
                "Authorization": "Bearer" + localStorage.getItem("access_token")
            },
            data: data,
            success: function (res) {
                if (res.success === true) {
                    outputSpreadsheetController.state.data = res.result;
                    outputSpreadsheetController.setState(outputSpreadsheetController.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    deleteOutputSpreadSheetApi = (id) => {
        let outputSpreadsheetController = this;
        $.ajax({
            url: "/api/spreadsheet-intent",
            async: false,
            method: 'POST',
            headers: {
                'Authorization': "Bearer " + localStorage.getItem("access_token"),
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: { intentId: id },
            success: function (res) {
                if (res.success === true) {
                    outputSpreadsheetController.setState({ hideDeletePopup: false });
                    outputSpreadsheetController.fetchOutputSpreadSheetDataApi();
                    outputSpreadsheetController.notifyDeleteSuccess();
                } else {
                    outputSpreadsheetController.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    notifyDeleteSuccess() {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
          &nbsp;&nbsp;Spreadsheet Deleted Successfully</b>, {
            position: "top-center"
        });
    }

    openSpreadsheet = (props, e) => {
        window.open("https://docs.google.com/spreadsheets/d/" + props.original.spreadSheetId, "_blank")

    }

    render() {
        const { data } = this.state

        const columns = [
            {
                Header: <b>Spreadsheet Title</b>,
                accessor: 'capturedIntent',
                sortable: false,
                Cell: props => (<div className="input"
                    style={{ width: '98%', padding: '8px', paddingLeft: '2px' }}
                    contentEditable={false}
                    suppressContentEditableWarning
                    type="text" id={"name" + props.index}
                >{props.original.name}</div>
                )
            },
            {
                Header: <b>Action</b>,
                accessor: 'ssurl',
                sortable: false,
                Cell: props => (<div id="action">
                    <div style={{ marginTop: "-6px" }}>
                        {/* Map to Intent Button */}
                        <p>  <button className="btn2 table-action-button"
                            onClick={(e) => {
                                this.openSpreadsheet(props, e)
                            }}>
                            Open Spreadsheet</button> <b />

                            {/* Delete Button*/}
                            <button style={{ backgroundColor: "#ffffff", border: "none" }}
                                title="Delete" >
                                <img className="img-responsive" src="./assets/images/baseline_delete_white_24dp.png"
                                    style={{
                                        marginTop: '6px',
                                        backgroundColor: '#282a65', borderRadius: '5px', padding: '1px'
                                    }}
                                    onClick={() =>
                                        this.setState({
                                            hideDeletePopup: true,
                                            propsId: props.original.id
                                        })
                                    }
                                />
                            </button>
                        </p>
                    </div>
                </div>)
            }
        ]

        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!(this.state.showLoader)}
                    height={400}
                    width={50}
                    style={{ textAlign: 'center' }} />
                <div style={{ display: this.state.showLoader ? 'block' : 'none' }}>

                    {/* for toaster */}
                    <link rel="stylesheet" href="./assets/css/ReactToastify.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="./assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="./assets/css/react-table-height.css" />


                    {/* for dialog component */}
                    <link href="./assets/css/ej2-base.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-buttons.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-react-popups.css" rel="stylesheet" />
                    <link href="./assets/css/ej2-inputs.css" rel="stylesheet" />
                    <link href="./assets/css/screenResolution.css" rel="stylesheet" />
                    <div className="col-sm-12" style={{ backgroundColor: '#F9F9FB', marginBottom: '10px' }}>
                        <div className="row">
                            <div className="col-sm-7">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '10px', marginLeft: '7px'
                                }}>Output Spreadsheets</h6>
                            </div>
                        </div>
                    </div>
                    <ReactTable
                        data={data}
                        columns={columns}
                        defaultPageSize={10}
                        pageSizeOptions={[5, 10, 15]}
                        onPageChange={this.onPageChange}
                        page={this.state.pageNum}
                        style={{
                            backgroundColor: 'white',
                            marginRight: '12px', marginLeft: '12px'
                        }}
                    />

                    <ToastContainer className="Toast-at-center" />
                    {/*Dialog Component For Deletion Confirmation*/}
                    <DialogComponent width='400px' animationSettings={this.settings}
                        header='Output Spreadsheet' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog}
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete the spreadsheet?<br />Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>

                </div>
            </div>
        )
    }
}
export default OutputSpreadsheet;





// WEBPACK FOOTER //
// ./src/projectmgmt/reports/statistics/OutputSpreadsheet.js